import React, { createContext, useContext, useMemo } from 'react';
const noop = () => { };
const warnAndNoop = (name) => () => {
    if (typeof window !== 'undefined' && window.__ISN_DEBUG__) {
        console.warn(`Extras.${name} not wired yet on OFv2`);
    }
};
const defaultExtras = {
    openQuickSearchDialog: warnAndNoop('openQuickSearchDialog'),
    closeQuickSearchDialog: noop,
    openQuickCalendarDialog: warnAndNoop('openQuickCalendarDialog'),
    closeQuickCalendarDialog: noop,
    openCsiDialog: warnAndNoop('openCsiDialog'),
    closeCsiDialog: noop,
    openLogCallDialog: warnAndNoop('openLogCallDialog'),
    closeLogCallDialog: noop,
    openTaskDialog: warnAndNoop('openTaskDialog'),
    closeTaskDialog: noop,
};
const Ctx = createContext(null);
export function AppContextProvider({ children, extras, }) {
    const value = useMemo(() => {
        const appData = (typeof window !== 'undefined' && typeof window.isnapp === 'function')
            ? window.isnapp()
            : {};
        return {
            appData,
            extras: { ...defaultExtras, ...extras },
        };
    }, [extras]);
    return React.createElement(Ctx.Provider, { value: value }, children);
}
export function useAppContext() {
    const ctx = useContext(Ctx);
    if (!ctx) {
        throw new Error('useAppContext must be used within AppContextProvider');
    }
    return ctx;
}
